import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function CustomDatePicker({
  label,
  visitDate,
  setvisitDate,
  setpagination,
}) {
  const handleonChange = (date) => {
    setpagination && setpagination(dayjs(date).format("YYYY-MM-DD"));
    setvisitDate(dayjs(date).format("YYYY-MM-DD"));
  };

  // Function for disable future dates.
  const disableFutureDates = (date) => {
    return date > new Date(); //
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          label={label}
          defaultValue={dayjs(visitDate)}
          onChange={handleonChange}
          renderInput={(params) => <TextField {...params} />}
          shouldDisableDate={disableFutureDates}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
